'use client'

import { useMemo } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js'
import { Line } from 'react-chartjs-2'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
)

interface TaxRateChartv2Props {
  data: { year: number; rate: number }[]
}

export default function TaxRateChartv2({ data }: TaxRateChartv2Props) {
  const chartData = useMemo(() => {
    return {
      labels: data.map((d) => d.year.toString()),
      datasets: [
        {
          label: 'Thuế suất (%)',
          data: data.map((d) => d.rate),
          borderColor: '#1E40AF',
          backgroundColor: 'rgba(30, 64, 175, 0.1)',
          borderWidth: 2,
          tension: 0.3,
          pointRadius: 5,
          pointHoverRadius: 7,
          pointBackgroundColor: '#1E40AF',
          pointBorderColor: '#ffffff',
          pointBorderWidth: 2,
          fill: true,
        },
      ],
    }
  }, [data])

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        padding: 12,
        titleFont: {
          size: 13,
          weight: 'bold' as const,
        },
        bodyFont: {
          size: 12,
        },
        borderColor: '#e5e5e5',
        borderWidth: 1,
        callbacks: {
          title: function (context: any) {
            return `Năm ${context[0].label}`
          },
          label: function (context: any) {
            return `Thuế suất: ${context.raw}%`
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: Math.max(...data.map((d) => d.rate), 12),
        grid: {
          display: true,
          color: '#f5f5f5',
          drawBorder: true,
        },
        ticks: {
          font: {
            size: 12,
          },
          color: '#525252',
          callback: function (value: any) {
            return value + '%'
          },
        },
      },
      x: {
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: 12,
          },
          color: '#525252',
          padding: 8
        },
      },
    },
  } as any

  return (
    <div className="relative h-[300px] w-full">
      <Line data={chartData} options={options} />
    </div>
  )
}
